import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-rose-950 text-white" data-id="element-86">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-87">
        <ShieldCheck className="w-20 h-20 text-rose-300 mx-auto mb-6" data-id="element-88" />
        <h2 className="text-3xl md:text-4xl font-black mb-8" data-id="element-89">
          🛡️ GARANTÍA LENGUA PACK — 7 DÍAS
        </h2>

        <div className="text-xl md:text-2xl font-medium space-y-2 mb-10 text-rose-100" data-id="element-90">
          <p data-id="element-91">Abrís los 12 tomos.</p>
          <p data-id="element-92">Revisás los 6 bonus.</p>
          <p data-id="element-93">Los usás en el aula si querés.</p>
        </div>

        <div className="bg-rose-900 rounded-2xl p-8 mb-10 border border-rose-800" data-id="element-94">
          <p className="text-2xl font-bold mb-4" data-id="element-95">
            Si en 7 días no es lo que esperabas:
          </p>
          <ul className="text-xl space-y-2 text-rose-200 font-medium" data-id="element-96">
            <li data-id="element-97">Te devolvemos el 100%.</li>
            <li data-id="element-98">Sin preguntas.</li>
            <li data-id="element-99">Sin formularios.</li>
            <li data-id="element-100">Sin drama.</li>
          </ul>
        </div>

        <p className="text-lg text-rose-300 italic" data-id="element-101">
          La confianza que tenemos en el Lengua Pack nos permite ofrecerte eso.
          <br data-id="element-102" />
          Más de 1.500 docentes ya lo saben.
        </p>
      </div>
    </section>;
}